import { fetchApi } from '@/config/axiosSetting';
import {
  BodyWagesListParamsType,
  BodyWagesListResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyWagesList/getBodyWagesListQuery.type';

export const getBodyWagesListQueryFunction = (
  params: BodyWagesListParamsType,
): Promise<BodyWagesListResponseType> =>
  fetchApi.get(
    `body/reports/${params?.id}/accident_users/damaged/adjusting/wages/list/`,
  );
